import { Component } from '@angular/core';

@Component({
    selector: 'ca-wide-page',
    templateUrl: 'wide-page.component.html',
    styleUrls: ['./wide-page.component.scss'],
    standalone: false
})
export class CaWidePage {}
